/* import __COLOCATED_TEMPLATE__ from './input.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
// @ts-ignore
import { ref } from 'ember-ref-bucket';

interface Args {
  value: string | null;
  onSubmit: (value: string) => void;
}

interface Signature {
  Args: Args;
}

export default class Input extends Component<Signature> {
  @service declare session: Session;

  @tracked scrollHeight = 72;
  @tracked editMode = false;
  @ref('textarea') textarea!: HTMLElement;

  @action
  resizeAndSubmit(value: string) {
    this.scrollHeight = this.textarea.scrollHeight + 5;
    this.args.onSubmit(value);

    this.editMode = false;
  }

  @action submitValue(value: string) {
    this.args.onSubmit(value);

    this.editMode = false;
  }

  updateTextAreaSize = modifier((element: Element) => {
    this.scrollHeight = element.scrollHeight + 5;
  });

  get heightStyle() {
    return `height: ${this.scrollHeight}px;`;
  }

  get valueToString() {
    return this.args.value?.toString();
  }

  @action edit(event: Event) {
    if (event.target instanceof Element) {
      if (event.target?.getAttribute('data-inline-link') === 'true') {
        event.stopPropagation();
        return;
      }
    }

    this.editMode = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::Attribute::Editor::Input': typeof Input;
    'inbox2/conversation-details-sidebar/attribute/editor/input': typeof Input;
  }
}
